angular.module('invoice')
    .factory('InvoiceProject', function ($resource) {
        return $resource('/crm/api/invoice-project/:id', {}, {
            list: {method: 'GET', isArray: false},
            get: {method: 'GET'},
            update: {method: 'PUT', params: {id: "@id"}},
            remove: {method: 'DELETE'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/invoice-project/autocomplete'}
        })
    })
    .constant('InvoiceProjectConst', {
        eventUpdate: 'invoice-project.updated'
    })
    .service('InvoiceProjectService', function ($rootScope, toastr, modals, InvoiceProject, InvoiceProjectConst) {
        this.edit = id => {
            return InvoiceProject.get({id: id}, entity => editModal(entity))
        }
        this.addModal = () => {
            let entity = {
                id: null
            }
            return editModal(entity)
        }
        this.remove = item => {
            return modals.confirmDelete(item.name, () => InvoiceProject.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast(InvoiceProjectConst.eventUpdate)))
        }

        function editModal(entity) {
            return modals.open('app/invoice/invoice-project/edit-modal.html', 'InvoiceProjectDialogController', entity, {size: "lg", windowClass: "dialogs-default invoice-project-modal-full"}, "$ctrl")
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('invoiceProjectList', {
            parent: 'app',
            url: '/settings/invoice-project?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_INVOICE_SETTINGS_READ']
            },
            views: {
                'content@': 'invoiceProjectList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (InvoiceProject, $stateParams) => InvoiceProject.list(angular.copy($stateParams)).$promise
            }
        })
        $stateProvider.state('invoiceProjectShowFull', {
            parent: 'app',
            url: '/settings/invoice-project/{id}?tab',
            params: {
                tab: {value: null, squash: true, dynamic: true}
            },
            data: {
                authorities: ['ROLE_INVOICE_SETTINGS_READ']
            },
            views: {
                'content@': {
                    templateUrl: 'app/invoice/invoice-project/show.html',
                    controller: 'InvoiceProjectShowFullController',
                    controllerAs: '$ctrl'
                }
            },
        })
    })
